"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MicMuteIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M18.008 16.594l2.64 2.64a1 1 0 01-1.414 1.414l-2.496-2.496A6.976 6.976 0 0113 19.93V23h-2v-3.07A7.002 7.002 0 015 13v-1a1 1 0 012 0v1a5 5 0 008.322 3.737l-1.418-1.419a3.01 3.01 0 01-.014.012L9 10.44v-.026L3.678 5.092a1 1 0 011.414-1.414L9 7.586V4a3 3 0 016 0v9c0 .184-.016.363-.048.538l1.58 1.579c.3-.643.468-1.36.468-2.117v-1a1 1 0 012 0v1a6.967 6.967 0 01-.992 3.594zm-5.597-.622A3 3 0 019 13v-.44l3.411 3.412z"
  }));
});
MicMuteIcon.category = 'Media';
var _default = MicMuteIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/MicMuteIcon.js
// module id = 1115
// module chunks = 0